import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { selectFilter } from './duck/actions';


export const FilterText = props => {

    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const inputId = props.textFieldName ? `filter-text-${props.textFieldName}` : 'filter-text';

    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;
        const onKeyDown = (e) => {
            if (e.key !== 'Enter' && e.keyCode !== 13) return;
            e.preventDefault();
            dispatch(selectFilter(null, props.textFieldName));
        };
        el.addEventListener('keydown', onKeyDown);
        return () => el.removeEventListener('keydown', onKeyDown);
    }, [dispatch, props.textFieldName]);

    return (<div className="filter-text">
        <input ref={inputRef} type="text" className="filter-text__text" id={inputId} />
        <svg className="icon icon-user filter-text__icon" onClick={() => {
            dispatch(selectFilter(null, props.textFieldName));
        }}>
            <use xlinkHref="../img/sprite.svg#icon-search"></use>
        </svg>
    </div>)
}
